import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const memberState = {
  memberLists: null,
  addMemberLists: null,
  updateMemberLists: null,
  editMemberLists: null,
  memberGameLists: null,
  memberGameListsBalance: null,
  memberGameBalance: null,
  memberTransfer: null,
  addGameId: null,
  memberReportLists: null,
  changeMemberAppPassword: null,
  memberGameLogReport: null,
  vBossReport: null,
  error: null,
  listLoading: false,
  actionsLoading: false,
  searchLoading: false,
  overlayLoading: false,
  isRefresh: false,
};

export const memberSlice = createSlice({
  name: "member",
  initialState: memberState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.OVERLAY) {
        state.overlayLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.OVERLAY) {
        state.overlayLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },

    memberListsFetch: (state, action) => {
      state.actionsLoading = false;
      state.memberLists = action.payload.data ?? {};
    },
    addMemberFetch: (state, action) => {
      state.actionsLoading = false;
      state.addMemberLists = action.payload.data ?? {};
    },
    updateMemberFetch: (state, action) => {
      state.actionsLoading = false;
      state.updateMemberLists = action.payload.data ?? {};
    },
    memberPromotionRemoved: (state) => {
      state.overlayLoading = false;
    },
    editMemberFetch: (state, action) => {
      state.actionsLoading = false;
      state.editMemberLists = action.payload.data ?? {};
    },
    memberGameListsFetch: (state, action) => {
      state.actionsLoading = false;
      state.memberGameLists = action.payload.data ?? {};
    },
    memberGameListsBalanceFetch: (state, action) => {
      state.actionsLoading = false;
      state.memberGameListsBalance = action.payload.data ?? {};
    },
    memberGameBalanceFetch: (state, action) => {
      state.searchLoading = false;
      state.memberGameBalance = action.payload.data ?? {};
    },
    clearMemberGameBalance: (state) => {
      state.memberGameBalance = null;
    },
    memberTransferFetch: (state, action) => {
      state.actionsLoading = false;
      state.memberTransfer = action.payload.data ?? {};
    },
    addGameIdFetch: (state, action) => {
      state.actionsLoading = false;
      state.addGameId = action.payload.data ?? {};
    },
    memberReportListsFetch: (state, action) => {
      state.actionsLoading = false;
      state.memberReportLists = action.payload.data ?? {};
    },
    memberGatewayListsFetch: (state, action) => {
      state.actionsLoading = false;
      state.memberGatewayLists = action.payload.data ?? {};
    },
    memberTelcoListsFetch: (state, action) => {
      state.actionsLoading = false;
      state.memberTelcoLists = action.payload.data ?? {};
    },
    changeMemberAppPasswordFetch: (state, action) => {
      state.actionsLoading = false;
      state.changeMemberAppPassword = action.payload.data ?? {};
    },
    memberGameLogReportFetch: (state, action) => {
      state.actionsLoading = false;
      state.memberGameLogReport = action.payload.data ?? {};
    },
    vBossReportFetch: (state, action) => {
      state.actionsLoading = false;
      state.vBossReport = action.payload.data ?? {};
    },
  },
});
